class VanillaHeaderHidden {
  constructor(pcFluidSize = 200, spThreshold = "20rem", options = {}) {
    this.targetSelector = options.targetSelector || "#js-page";

    // 指定位置を超えた時に付与するクラス
    this.hiddenClass = options.hiddenClass || "--is-header-hidden";

    // hidden状態で上方向にスクロールした時に付与するクラス
    this.fixVisibleClass = options.fixVisibleClass || "--is-fix-header-visible";

    this.pcBreakpoint = options.pcBreakpoint || 768;

    // PC時：fluidVw(200, 1440) 相当
    this.pcFluidSize = Number(pcFluidSize);
    this.pcViewport = options.pcViewport || 1440;

    // SP時：20rem
    this.spThreshold = spThreshold;

    // 微細なスクロール揺れを無視する値
    this.scrollDelta = options.scrollDelta || 4;

    this.target = document.querySelector(this.targetSelector);

    this.threshold = 0;
    this.ticking = false;

    this.lastScrollY = this.getScrollY();

    this.init();
  }

  init() {
    if (!this.target) return;

    this.updateThreshold();
    this.onScroll();

    window.addEventListener("scroll", this.handleScroll.bind(this), {
      passive: true,
    });

    window.addEventListener("resize", this.handleResize.bind(this), {
      passive: true,
    });
  }

  getScrollY() {
    return window.scrollY || window.pageYOffset || 0;
  }

  getRootFontSize() {
    return parseFloat(
      window.getComputedStyle(document.documentElement).fontSize,
    );
  }

  remToPx(rem) {
    return rem * this.getRootFontSize();
  }

  fluidVwToPx(size, viewport) {
    return (size / viewport) * window.innerWidth;
  }

  parseLengthToPx(value) {
    if (typeof value === "number") {
      return value;
    }

    const stringValue = String(value).trim();

    if (stringValue.endsWith("rem")) {
      return this.remToPx(parseFloat(stringValue));
    }

    if (stringValue.endsWith("px")) {
      return parseFloat(stringValue);
    }

    return parseFloat(stringValue);
  }

  updateThreshold() {
    const isPc = window.innerWidth >= this.pcBreakpoint;

    this.threshold = isPc
      ? this.fluidVwToPx(this.pcFluidSize, this.pcViewport)
      : this.parseLengthToPx(this.spThreshold);
  }

  handleScroll() {
    if (this.ticking) return;

    this.ticking = true;

    window.requestAnimationFrame(() => {
      this.onScroll();
      this.ticking = false;
    });
  }

  handleResize() {
    this.updateThreshold();
    this.onScroll();
  }

  onScroll() {
    const scrollY = this.getScrollY();
    const isPastThreshold = scrollY >= this.threshold;

    const isScrollingUp = scrollY < this.lastScrollY - this.scrollDelta;
    const isScrollingDown = scrollY > this.lastScrollY + this.scrollDelta;

    if (isPastThreshold) {
      this.target.classList.add(this.hiddenClass);

      if (this.target.classList.contains(this.hiddenClass) && isScrollingUp) {
        this.target.classList.add(this.fixVisibleClass);
      }

      if (isScrollingDown) {
        this.target.classList.remove(this.fixVisibleClass);
      }
    } else {
      this.target.classList.remove(this.hiddenClass);
      this.target.classList.remove(this.fixVisibleClass);
    }

    this.lastScrollY = scrollY;
  }
}

export default VanillaHeaderHidden;
